import '@cabourg/scss/app-wpet-list-aside.scss';
import WpetListAside from '@cabourg/js/wpet/list-aside';
import WpetInteractiveMap from '@cabourg/js/wpet/interactive-map';

if  (typeof WhiteLabel !== 'undefined' ) {
    new WpetListAside();
    new WpetInteractiveMap();
}

document.addEventListener( "DOMContentLoaded", function () {
    new WpetListAside();
    new WpetInteractiveMap();
});
